<script>
    export let context; context;
    function back() {
        window.history.back();
    }
</script>
<section class="hero is-danger">
    <div class="hero-body">
        <div class="container">
            <h1 class="title">
                Page Not Found
            </h1>
            <h2 class="subtitle">
                We could not find the page you are looking for.
                
            </h2>
            <a class="button is-white" href="/">Home</a>
            <button class="button is-white" on:click={back}>Back</button>
        </div>
    </div>
</section>